import { useTranslation } from 'react-i18next';
import { RhfImageField, type RhfImageFieldProps } from './shared/RhfImageField';

export type RegistrationImageFieldProps = Omit<RhfImageFieldProps, 'label'> & {
  label?: string;
};

/**
 * `RegistrationImageField` — RHF-bound document upload for
 * `Org.legal.registrationImage` (scanned commercial registration
 * — PDF or photo).
 *
 * Accepts PDFs in addition to images because most users have a
 * scanned PDF copy of their CR ready to share with lenders. The
 * uploaded blob is sent as `ImageWithUpload` and the backend
 * stores the resulting Cloudinary slot on
 * `Org.legal.registrationImage`.
 */
export function RegistrationImageField(props: RegistrationImageFieldProps) {
  const { t } = useTranslation('m-organization');
  return (
    <RhfImageField
      {...props}
      label={props.label ?? t('form.cr_picture.title')}
      uploadLabel={props.uploadLabel ?? t('form.cr_picture.title')}
    />
  );
}
